import React from 'react'

import { employersPaySchedules } from 'rails_routes'
import { Banner, ButtonLink } from 'slab'

interface PayScheduleStatusProps {
  customScheduleCount: number
  unverifiedScheduleCount?: number
}

const PayScheduleStatus: React.FC<PayScheduleStatusProps> = ({
  customScheduleCount,
  unverifiedScheduleCount = 0,
}) => {
  const getScheduleCountText = () => {
    // If there are unverified schedules, show unverified count as main text
    if (unverifiedScheduleCount > 0) {
      if (unverifiedScheduleCount === 1) {
        return '1 unverified schedule'
      } else {
        return `${unverifiedScheduleCount} unverified schedules`
      }
    }

    // Otherwise show custom schedule count
    if (customScheduleCount === 0) {
      return 'No custom schedules'
    } else if (customScheduleCount === 1) {
      return '1 custom pay schedule'
    } else {
      return `${customScheduleCount} custom pay schedules`
    }
  }

  const getButtonText = () => {
    return unverifiedScheduleCount > 0 ? 'Verify' : 'Manage'
  }

  const getBannerMessage = () => {
    if (unverifiedScheduleCount > 0) {
      return `We found ${unverifiedScheduleCount} schedule${unverifiedScheduleCount === 1 ? '' : 's'} in your payroll system. You must verify all schedules before they can be used.`
    }
    return null
  }

  return (
    <>
      {unverifiedScheduleCount > 0 && (
        <div className='mb-6'>
          <Banner
            type='warning'
            title={getBannerMessage()}
          />
        </div>
      )}
      <div className='bg-white border border-gray-200 rounded-2xl shadow-sm mb-6'>
        <div className='flex flex-col md:flex-row md:justify-between p-6 gap-y-4 md:gap-x-6 md:items-center'>
          <div className='flex flex-col'>
            <div className='flex items-center'>
              <span className='text-sm font-medium text-gray-900'>
                {getScheduleCountText()}
              </span>
            </div>
          </div>

          <div className='flex items-center'>
            <ButtonLink
              href={employersPaySchedules.index()}
              variant='secondary'
              size='small'
            >
              {getButtonText()}
            </ButtonLink>
          </div>
        </div>
      </div>
    </>
  )
}

export default PayScheduleStatus
